import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';
import MerchantFieldLabelMap from 'app/models/typescript/MerchantFieldLabelMap';
import PartnerGroupEnum = Boo.Objects.Enums.PartnerGroupEnum;
import { SessionStorageService } from './session-storage.service';
import Utils from '../../app/shared/utils';

@Injectable({
  providedIn: 'root'
})

export class MerchantFieldsService {
  private baseUrl = `${environment.urlConfig.serviceUrl}/merchantfields`;

  constructor(
    private http: HttpClient,
    private sessionStorageService: SessionStorageService) { }

  export(statuses: Boo.Objects.Enums.StatusEnum[]): Observable<any> {
    return this.http.post(`${this.baseUrl}/Export`, { statuses: statuses });
  }

  import(merchantFieldsList: Boo.Objects.CustomerMerchantFields[]): Observable<any> {
    return this.http.post(`${this.baseUrl}/Import`, { merchantFieldsList: merchantFieldsList })
  }

  get(customerId: number): Observable<Boo.Objects.CustomerMerchantFields> {
    const params = new HttpParams().set('customerId', customerId);
    return this.http.get<Boo.Objects.CustomerMerchantFields>(this.baseUrl, { params: params });
  }

  save(merchantFields: Boo.Objects.CustomerMerchantFields): Observable<any> {
    return this.http.post<void>(this.baseUrl, merchantFields)
  }

  // Changes to merchant labels should also be added to customerinformation.js and editmerchantfields.js
  public generateLabelMapping(partnerId: number): Observable<MerchantFieldLabelMap> {
    return this.sessionStorageService.getStaticData()
      .pipe(
        map((staticData) => {
          const labelMap = new MerchantFieldLabelMap();

          if (partnerId === Boo.Objects.Enums.PartnerEnum.FoundDigital) {
            labelMap.IdLabel.Value = 'Advertiser ID';
            labelMap.SourceLabel.Value = 'BC Product ID';
            labelMap.ProposalIdLabel.Value = 'MSA Name';
            labelMap.CategoryLabel.Value = 'MSA Email';
            labelMap.CategoryIdLabel.Value = 'MSA Phone';
            labelMap.SubCategoryLabel.Value = 'Heading';
            labelMap.SubCategoryIdLabel.Value = 'SiteSmart (Y/N)';
            labelMap.ConsultantLabel.Value = 'SiteSmart Customisation (Y/N)';
            labelMap.UdacLabel.Value = 'Need Click Manager PPC Campaign (Y/N)';
            labelMap.ProductCodeLabel.Value = 'Product Code';
            labelMap.ItemIdLabel.Value = 'Web Specialist';
            labelMap.MiscIdLabel.Value = 'Web Specialist Email Address';
          } else if (Utils.partnerInPartnerGroup(partnerId, PartnerGroupEnum.GoDaddy, staticData.PartnerGroups)) {
            labelMap.CustomerValueLabel.Value = 'GoDaddy ID';
            labelMap.SourceLabel.Value = 'Plan Name';
            labelMap.ProductCodeLabel.Value = 'Term Length';
            labelMap.ContractEndDateLabel.Value = 'Pre-Pay Plan Expiration';
            labelMap.CategoryLabel.Value = 'NPS Score';
            labelMap.ConsultantLabel.Value = 'NPS Score Updated';
            labelMap.ProposalIdLabel.Value = 'Auto-Renew Status';
          } else if (partnerId === Boo.Objects.Enums.PartnerEnum.Herold) {
            labelMap.ConsultantContactLabel.Value = 'Customer Email for Reports';
          } else if (partnerId === Boo.Objects.Enums.PartnerEnum.HeiseRegioConcept) {
            labelMap.ConsultantContactLabel.Value = 'Customer Email for Reports';
          } else if (partnerId === Boo.Objects.Enums.PartnerEnum.HeiseRegioConceptÖsterreich) {
            labelMap.ConsultantContactLabel.Value = 'Customer Email for Reports';
          } else if (partnerId === Boo.Objects.Enums.PartnerEnum.HeiseRegioConceptSchweiz) {
            labelMap.ConsultantContactLabel.Value = 'Customer Email for Reports';
          }
  
          return labelMap;
        }));
  }
}
